import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import { isset } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

// Consider using the new <Button> component instead
class NextButton extends ApplicationComponent {
  icon() {
    const names = {
      "fa-kit": true,
      "mr-1": true,
      "fa-spinner": this.props.processing,
      "fa-spin": this.props.processing,
    }
    if (isset(this.props.icon) && !this.props.processing) {
      names[this.props.icon] = true
    }
    if (isset(this.props.icon) || this.props.processing) {
      return <i className={classNames(names)} />
    }
  }

  text() {
    if (this.props.processing === true) {
      return this.props.processingText
    } else {
      return this.props.text
    }
  }

  btnClass() {
    return isset(this.props.btnClass)
      ? "btn " + this.props.btnClass
      : "btn btn-secondary"
  }

  render() {
    return (
      <button
        id={this.props.id}
        type="button"
        className={this.btnClass()}
        disabled={this.props.processing || this.props.disabled}
        onClick={this.props.click}
        data-confirm={this.props.confirm}
      >
        {this.icon()}
        {this.text()}
      </button>
    )
  }
}

NextButton.propTypes = {
  id: PropTypes.string,
  processing: PropTypes.bool,
  disabled: PropTypes.bool,
  click: PropTypes.func,
  confirm: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string.isRequired,
  processingText: PropTypes.string,
  btnClass: PropTypes.string,
}

export default NextButton
